import type {ColumnFragment, ColumnRefOptionsFragment, ValueFragment} from "app/gql/graphqlSchema";
import {UnreachableCaseError} from "ts-essentials";
import {DisplayText} from "./display/DisplayText";
import {DisplayEmployeeRef} from "app/employee/controlCard/display/DisplayEmployeeRef";
import {DisplayChoice} from "app/employee/controlCard/display/DisplayChoice";
import {DisplayTime} from "app/employee/controlCard/display/DisplayTime";
import {DisplayDate} from "app/employee/controlCard/display/DisplayDate";
import {DisplayMultiChoice} from "app/employee/controlCard/display/DisplayMultiChoice";
import {DisplaySignature} from "app/employee/controlCard/display/DisplaySignature";
import {DisplayNumber} from "app/employee/controlCard/display/DisplayNumber";
import {DisplayAttachmentCollection} from "app/employee/controlCard/display/DisplayAttachmentCollection";

interface Props {
  column: ColumnFragment;
  value: ValueFragment;
  columnRefOptions: ColumnRefOptionsFragment[];
}

export const DisplayValue = ({value, column, columnRefOptions}: Props) => {
  if (value.__typename === "ControlCardExpressionValue") {
    return <DisplayValue column={column} columnRefOptions={columnRefOptions} value={value.result} />;
  } else {
    switch (column.__typename) {
      case "ControlCardLabelColumn":
      case "ControlCardTextColumn":
      case "ControlCardComboBoxColumn":
        return <DisplayText value={value} />;
      case "ControlCardChoiceColumn":
        return <DisplayChoice column={column} value={value} />;
      case "ControlCardMultiChoiceColumn":
        return <DisplayMultiChoice column={column} value={value} />;
      case "ControlCardNumberColumn":
        return <DisplayNumber column={column} value={value} />;
      case "ControlCardTimeColumn":
        return <DisplayTime column={column} value={value} />;
      case "ControlCardDateColumn":
        return <DisplayDate column={column} value={value} />;
      case "ControlCardEmployeeRefColumn":
        return <DisplayEmployeeRef column={column} columnRefOptions={columnRefOptions} value={value} />;
      case "ControlCardSignatureColumn":
        return <DisplaySignature value={value} />;
      case "ControlCardAttachmentCollectionColumn":
        return <DisplayAttachmentCollection column={column} value={value} />;
      case "ControlCardTransposedColumn":
      case "ControlCardTicketColumn":
      case "ControlCardNestedControlCardColumn":
        return null;
      default:
        throw new UnreachableCaseError(column);
    }
  }
};
